import React from "react";
import {send_add_cmd} from "../../etc/cmd";
import c from "../../etc/Const";

const NewModule = ({id, scenario}) => {

    function newModule() {
        let co = {};
        co.id = c.uuidv4().slice(-8);
        co.typename = 'module'
        co.scenario = scenario
        co.w = 6
        co.h = 3
        send_add_cmd(co)
    }

    function handleDragStart(e) {
        e.dataTransfer.setData("id", id);
        e.dataTransfer.setData("name", "module");
        e.dataTransfer.setData("action", "add");
    }

    function handleDrag(e) {
        e.preventDefault();
    }

    return(
        <div
            className={'bubble mock'}
            onDrag={handleDrag}
            onDragStart={handleDragStart}
            draggable={true}
            onClick={newModule}
        >+</div>
    )
}

export default NewModule
